import React, { Component } from "react";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import Title from "../../UI/Text/Title";
// import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
// import { WHATSAPP_ACCOUNT_LIST } from "../../UI/Table/ColumnConst";
import { HOST_URL, WhstappAccountList } from "../api/Api";
// import {
//   faEdit,
//   faSignInAlt,
//   faUserLock,
// } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Axios from "axios";
import { FiInfo } from "react-icons/fi";
import { BsCheckCircleFill } from "react-icons/bs";
import { BsExclamationCircleFill } from "react-icons/bs";
import Dialog from "react-dialog";
import JSONPretty from "react-json-pretty";
import Spining from "../../UI/Spining/Spining";
import { handleUserLog } from "../../Utils/Utils";

class WhatsappNumberList extends Component {
  constructor() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const username = lStorage.user.username;
    const token = lStorage.token;
    const parent_type = lStorage.user.parent_type;
    const reseller_id = lStorage.user.reseller_id;

    super();

    this.state = {
      userId: user_id,
      username: username,
      reseller_id: reseller_id,
      wabaId: null,
      phoneNumberId: null,
      token: token,
      parent_type: parent_type,
      whatsappNumber: [],
      setIsLoading: true,
      ErrorResponse: "",
      route: "",
      dialogOpen: false,
      fbauthToken:
        "EABFalxmwxMkBAKPaaVqUHZABaCldGzuIUFOFEQDjoMqJDJFSZCctsq57ky2p29ma7CMZCd7vWZBFVAfXUnIOYhKkUc66RtTQpsREj6EEmKyLNwvMHZANAvDcbKsUOs3uHTiLrecZCbUdpU6cVQZCvQ3SYrDO5aouwcUZCyNJQU0JAQrQaPy3VlYU2wKxfNdGEbiGVimS2IIYoAZDZD",
      fbres: [],
      isDialogOpen: false,
      hasShownDialog: false,
      shownApprovedNumbers: [],
      currentItem: null,
      widgetData: null,
      checkMetaStatusData: [],
      metaStatusActive: false,
      metaStatusError: false,
      healthCheckAvailable: true,
      missingDialogOpen: false,
      missingItem: null,
      catalogueModal: false,
      catalogueId: '',
    };
  }
W
  componentDidMount() {
    this.getWhatsaAppNumberList();
    this.fetchRoute();
    // this.checkWhatsappWidget();
    // this.setState({ isDialogOpen: true });


  }

  // handleOpen = (item) => {
  //   if (item.status === 0) { 
  //     this.setState({ isDialogOpen: true, currentItem: item });
  //   }
  // };
  handleOpen = (item) => { // Log the item status
    if (item.status === 0) { // Check if status is pending (0)
      this.setState({ isDialogOpen: true, currentItem: item }, () => {
      });
      // console.log("Dialog should open, item.status:", item.status);
      this.setState({ isDialogOpen: true, currentItem: item }, () => {
        // console.log("Updated state (after setState):", this.state.isDialogOpen);
      });
    }
  };

  handleClose = () => {
    this.setState({ isDialogOpen: false, currentItem: null });
  };
  getWhatsaAppNumberList = async () => {
    let paramData = {
      user_id: this.state.userId,
      token: this.state.token,
      method: "retrieve",
    }
    WhstappAccountList(paramData).then((res) => {
      if (res.data.success === true) {
        const data = res.data.data;

        const wabaId = data[0]?.waba_id;
        const phoneNumberId = data[0]?.phone_number_id;

        this.setState({ wabaId, phoneNumberId });

        const { shownApprovedNumbers } = this.state;
        const hasApproved = data.find(
          (item) => item.status === 0 && !shownApprovedNumbers?.includes(item.id)
        );

        if (hasApproved) {
          const updatedShown = [...shownApprovedNumbers, hasApproved.id];
          // localStorage.setItem("shownApprovedNumbers", JSON.stringify(updatedShown));

          this.setState({
            isDialogOpen: true,
            shownApprovedNumbers: updatedShown,
          });
        }
        this.setState({ whatsappNumber: res.data.data, setIsLoading: false });

        const activeNumber = res.data.data.find((item) => item.status === 1);
        if (activeNumber) {
          this.checkHealthStatusAvailability(activeNumber.id, activeNumber.waba_id);
        }
      } else {
        this.setState({ ErrorResponse: res.data, setIsLoading: false });
      }
    });
  };


  healthStatus = async (phone_no_id) => {
    try {
      // if(!this.state.whatsappNumber.phone_number_id){
      //     return;
      // }
      const response = await fetch(`https://graph.facebook.com/v20.0/${phone_no_id}?fields=health_status`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${this.state.fbauthToken}`,
        },
      });
      const data = await response.json();
      this.setState({ fbres: data });
    } catch (error) {
      console.log(error.message);
    }
  };

  fetchRoute = async () => {
    try {
      let paramData = {
        user_id: this.state.userId,
        method: "retrieve",
        token: this.state.token
      }
      let { data } = await Axios.post(`${HOST_URL}/get_user_route.php`, paramData)
      //  console.log("Full API response:", data);
      if (data.success === true) {
        this.setState({
          route: Number(data.data),
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // checkWhatsappWidget = async () => {
  // try {
  //   const { userId, token } = this.state;
  //   const res = await Axios.post("https://napi.authkey.io/api/whatsapp_widget", {
  //     user_id: userId,
  //     token: token,
  //     method: "check_wp_widget",
  //   });

  //   if (res.data.success) {
  //     console.log("WhatsApp Widget Response:", res.data);
  //   } else {
  //     console.warn("API Error:", res.data.message);
  //   }
  // } catch (err) {
  //     console.error("Request Failed:", err);
  //   }
  // };

  ACDetails = (phone_no_id) => {
    if (this.state.route === 25) {
      this.setState({ dialogOpen: true });
      this.healthStatus(phone_no_id);
    }
  };
  handleCloseDialog = () => {
    this.setState({ dialogOpen: false });
  };

  checkHealthStatusAvailability = async (id, waba_id) => {
    try {
      const { data } = await Axios.post(`${HOST_URL}/wp_profile.php`, {
        user_id: this.state.userId,
        token: this.state.token,
        method: "check_health_status",
        id,
        waba_id,
      });
      if (data.success && data.message?.error) {
        this.setState({ healthCheckAvailable: false });
      } else if (data.success) {
        this.setState({ healthCheckAvailable: true });
      }
    } catch (e) {
      this.setState({ healthCheckAvailable: false });
    }
  };

  checkMetaStatus = async (id, waba_id) => {
    this.setState({ setIsLoading: true })
    let paramData = {
      user_id: this.state.userId,
      token: this.state.token,
      method: "check_health_status",
      id: id,
      waba_id: waba_id,
    }
    try {
      let { data } = await Axios.post(`${HOST_URL}/wp_profile.php`, paramData);
      if (data.success && data.message?.error) {
        this.setState({ setIsLoading: false });
        return;
      }

      if (data.success) {
        this.setState({ checkMetaStatusData: data.message.phone_numbers.data })
        this.setState({ metaStatusActive: true })
        this.setState({ setIsLoading: false })
      }
      else {
        // console.log(data)
        this.setState({ setIsLoading: false })
      }
    } catch (error) {
      console.log(error)
      this.setState({ setIsLoading: false })
    }
  }

  getMissingFields = (item) => {
    const missing = [];

    if (!item.business_website) missing.push("Business Website");
    if (!item.email) missing.push("Email");
    if (!item.address) missing.push("Profile Address");

    return missing;
  };

  render() {
    const allowedDomains = ["console.authkey.io", "localhost:3000"];
    const currentDomain = window.location.host;
    const showHelpButton = allowedDomains.includes(currentDomain);
    const { parent_type } = this.state;
    const adzResellers = [14532, 20355, 13713, 20075, 10774, 12003, 18748, 22287, 21363, 21474, 24065, 25319, 23739];
    const adzResellerDomains = [
      "flow.bulksmskolkata.com",
      "console.bulksmskolkata.com",
      "agent.bulksmskolkata.com",
      "panel.aditeksys.com",
      "panel.omnly.in",
      "console.telenama.in",
      "info@speqtrainnov.com",
      "cpaas.connect@gmail.com",
      "isha@onexsolutions.com"
    ];
    const currentDomain2 = window.location.hostname;
    const hideMMLite =
      adzResellers.includes(this.state.reseller_id) ||
      adzResellerDomains.some(domain => currentDomain2.includes(domain));


    return (
      <DashboardLayout>
        <main className="content">
          <div className="container-fluid p-0 d-flex flex-column align-items-center ">
            <div className="row w-100 mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                <Title
                  isButton={this.state.whatsappNumber.length > 0 ? false : true}
                  btnName={`Enable WhatsAPP Service `}
                  actionURL={`/dashboard/whatsapp-onboarding-new`}
                  onClick={() =>
                    handleUserLog(
                      "",
                      "clicked_enable_whatsapp_services_button",
                      "whatsapp",
                      "Enable WhatsApp Service click",
                      "whatsapp_onboarding",
                      "",
                      ""
                    )
                  }
                >
                  {" "}
                  WhatsApp Business{" "}
                </Title>
              </div>
              {this.state.setIsLoading && <Spining />}

              <div className="col-auto ml-auto text-right mt-n1 d-flex align-items-center" style={{ gap: '10px' }}>
               <Link to="/dashboard/whatsapp-onboarding-new">
                  <button onClick={() => handleUserLog("", "clicked_whatsapp_onboarding", "whatsapp", "WhatsApp Onboarding button click", "whatsapp_onboarding", "", "")} className="btn btn-primary btn-sm">
                    WhatsApp Onboarding
                  </button>
                </Link>
                {this.state.whatsappNumber.some((item) => item.status === 1) && (
                  <Link to="/dashboard/whatsapp-widget">
                    <button onClick={() => handleUserLog("" ,"clicked_create_widget_button", "whatsapp", "Create Widget button click", "whatsapp_onboarding" , "" , "")} className="btn btn-success btn-sm">
                      Create Widget
                    </button>
                  </Link>
                )}
                
                {showHelpButton && (
                  <a
                    href="https://authkey.io/blogs/whatsapp-onboarding-embedded-signup-authkey/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button onClick={() =>
                      handleUserLog(
                        "",
                        "clicked_help_embeded_signup",
                        "whatsapp",
                        "Help Document for signup",
                        "whatsapp_onboarding",
                        "",
                        ""
                      )
                    }
                      className="btn btn-success btn-sm">
                      <FiInfo style={{ fontSize: "18px", marginRight: "5px" }} />
                      Help
                    </button>
                  </a>
                )}
              </div>

            </div>

            {this.state.dialogOpen && (
              <Dialog
                modal={true}
                title="Response Status"
                isDraggable={true}
                onClose={this.handleCloseDialog}
                maxWidth={"md"}
              >
                {this.state.fbres.error ? <JSONPretty id="json-pretty" data={this.state.fbres.error}></JSONPretty> : <table className="table table-bordered table-striped">
                  <tbody>
                    <tr>
                      <td>Over All Status</td>
                      <td>{this.state.fbres.health_status?.can_send_message}</td>
                    </tr>
                    {this.state.fbres.health_status?.entities?.map((entity) => (
                      <>
                        <tr key={entity.id} >
                          <td>
                            {entity.entity_type} Status (Id : {entity.id})
                          </td>
                          <td>{entity.can_send_message}</td>
                        </tr>
                        {entity.errors && (
                          <div>
                            <h4>Errors</h4>
                            {entity.errors?.map((error, index) => (
                              <div key={index}>
                                <tr>
                                  <td>Error Code:</td>
                                  <td>{error.error_code}</td>
                                </tr>
                                <tr>
                                  <td>Description: </td>
                                  <td>{error.error_description}</td>
                                </tr>
                                <tr>
                                  <td>Possible Solution: </td>
                                  <td>{error.possible_solution}</td>
                                </tr>
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    ))}
                  </tbody>
                </table>}
              </Dialog>
            )}

            {this.state.isDialogOpen && parent_type !== "reseller" && (
              <Dialog
                modal={true}
                open={this.state.isDialogOpen}
                onClose={this.handleClose}
                maxWidth={"md"}
              >
                <div className="popup-overlay">
                  <div className="popup-container container">
                    <div className="col-md-12 row">
                      {/* Left Column */}
                      <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-start">
                        <h2 className="mb-2">Your WhatsApp Onboarding is Pending</h2>
                        <p>Complete your onboarding now and start creating powerful WhatsApp Widgets for your business.</p>
                        {/* <p className="mb-2">Click here to create WhatsApp Widget.</p> */}
                        {/* <Link to="/dashboard/whatsapp-widget" className="btn btn-primary">
                          Create Now
                        </Link> */}

                      </div>

                      {/* Right Column */}
                      <div className="col-12 col-md-6 p-0">
                        <img
                          src="https://authkey.io/img/whatsapp/whatsapp-widget.png"
                          alt="WhatsApp Widget Illustration"
                          className="img-fluid w-100 h-100 object-fit-cover"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog>
            )}


            {/* <AdvanceDataTable
              tableName={"Enable WhatsAPP Service"}
              tableCell={WHATSAPP_ACCOUNT_LIST}
              tableData={this.state.whatsappNumber}
              isLoading={this.state.setIsLoading}
              isError={this.state.ErrorResponse}
            /> */}

            <div className="table-responsive">
              <table className="table table-striped table-xs table-sm my-0">
                <thead>
                  <tr>
                    <th> ID</th>
                    <th> Company Name</th>
                    {/* <th> Account Status</th> */}
                    {/* <th> FB Manager ID </th> */}
                    <th> WhatsApp Number </th>
                    {this.state.healthCheckAvailable && <th>Check Health Status</th>}
                    <th>Daily Sending Limit</th>
                    <th>Account Status</th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.whatsappNumber?.map((item, i) => (
                    <tr key={i}>
                      <td>{item.id}</td>
                      <td>{item.comp_name}</td>
                      {/* <td>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <div
                            onClick={() => {
                              if (this.state.route === 25 && item.phone_number_id) {
                                this.ACDetails(item.phone_number_id);
                              }
                            }}
                          >
                            {item.account_status === 1 ? (
                              <button className="badge bg-primary" style={{ border: "none" }}>
                                {this.state.route === 25 ? "View" : "Green"}
                              </button>
                            ) : item.account_status === 2 ? (
                              <button className="badge bg-info" style={{ border: "none" }}>
                                {this.state.route === 25 ? "View" : "Yellow"}
                              </button>
                            ) : item.account_status === 3 ? (
                              <button className="badge bg-danger" style={{ border: "none" }}>
                                {this.state.route === 25 ? "View" : "Red"}
                              </button>
                            ) : (
                              <button className="badge badge-info" style={{ border: "none" }}>
                                N/A
                              </button>
                            )}
                          </div>

                          {item.status === 1 && (
                            <span
                              onClick={() => this.checkMetaStatus(item.id, item.waba_id)}
                              className="badge bg-warning"
                              style={{ cursor: "pointer" }}
                            >
                              Check Status
                            </span>
                          )}
                        </div>
                      </td> */}

                      {/* <td>{item.fb_businness_id}</td> */}
                      <td>{item.brand_number}</td>
                      {this.state.healthCheckAvailable && (
                        <td>
                          {item.status === 1 && (
                            <span
                              onClick={() => this.checkMetaStatus(item.id, item.waba_id)}
                              className="badge bg-warning ml-2"
                              style={{ cursor: "pointer" }}
                            >
                              Check Status
                            </span>
                          )}
                        </td>
                      )}
                      <td>{item.messaging_limit_tier}</td>
                      {/* <td>
                        <>
                          {item.status === 0 ? (
                            <span className="badge bg-warning mr-2">
                              {" "}
                              Pending{" "}
                            </span>
                          ) : (
                            <span className="badge btn-success">
                              <BsCheckCircleFill size={14} /> Live
                            </span>

                          )}
                        </>
                      </td> */}
                      <td>
                        <div className="d-flex align-items-center">
                          {/* Status */}
                          {item.status === 0 ? (
                            <span className="badge bg-warning">Pending</span>
                          ) : (
                            <span className="badge btn-success d-flex align-items-center">
                              <BsCheckCircleFill size={14} className="me-1" /> Live
                            </span>
                          )}

                          {/* Proper spaced warning icon */}
                          {this.getMissingFields(item).length > 0 && (
                            <BsExclamationCircleFill
                              className="text-danger"
                              size={16}
                              style={{ cursor: "pointer", marginLeft: "8px" }}
                              onClick={() =>
                                this.setState({
                                  missingDialogOpen: true,
                                  missingItem: item,
                                })
                              }
                            />
                          )}


                        </div>
                      </td>


                      <td>{item.created}</td>
                      <td>
                        <>
                          <Link to={`whatsapp/edit/${item.id}`}>
                            <span onClick={() =>
                              handleUserLog(
                                "",
                                "clicked_edit_onboarding_details_button",
                                "whatsapp",
                                "for edit the onboarding document",
                                "whatsapp_onboarding",
                                "",
                                ""
                              )
                            }
                              className="badge bg-success mr-2">
                              {" "}
                              Edit / Update{" "}
                            </span>{" "}
                          </Link>
                        </>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {this.state.missingDialogOpen && this.state.missingItem && (
              <Dialog
                modal
                onClose={() =>
                  this.setState({ missingDialogOpen: false, missingItem: null })
                }
                maxWidth="xs"
              >
                <div
                  style={{
                    width: 300,
                    borderRadius: "10%",
                    // background: "#ffffff",
                    // borderRadius: 14,
                    // padding: "22px 20px 18px",
                    // boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
                    textAlign: "center",
                  }}
                >
                  {/* Icon */}
                  <div
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #FFF7ED, #FFEDD5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 14px",
                    }}
                  >
                    <BsExclamationCircleFill size={20} color="#F59E0B" />
                  </div>

                  {/* Title */}
                  <h6
                    style={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#111827",
                      marginBottom: 4,
                      letterSpacing: "0.2px",
                    }}
                  >
                    Complete WhatsApp Setup
                  </h6>

                  {/* Subtitle */}
                  <p
                    style={{
                      fontSize: 12,
                      color: "#6B7280",
                      marginBottom: 14,
                      lineHeight: 1.4,
                    }}
                  >
                    Some required business details are missing.
                  </p>

                  {/* Missing fields box */}
                  <div
                    style={{
                      background: "#F9FAFB",
                      borderRadius: 10,
                      padding: "10px 12px",
                      marginBottom: 16,
                      textAlign: "left",
                    }}
                  >
                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: 16,
                        fontSize: 13,
                        color: "#374151",
                      }}
                    >
                      {this.getMissingFields(this.state.missingItem).map((f, i) => (
                        <li key={i} style={{ marginBottom: 4 }}>
                          {f}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Primary CTA */}
                  <Link
                    to={`whatsapp/edit/${this.state.missingItem.id}`}
                    onClick={() =>
                      this.setState({ missingDialogOpen: false, missingItem: null })
                    }
                  >
                    <button
                      style={{
                        width: "100%",
                        background: "linear-gradient(135deg, #22C55E, #16A34A)",
                        color: "#fff",
                        border: "none",
                        padding: "10px 0",
                        borderRadius: 8,
                        fontWeight: 600,
                        fontSize: 14,
                        cursor: "pointer",
                        boxShadow: "0 8px 20px rgba(34,197,94,0.25)",
                        transition: "0.2s ease",
                      }}
                    >
                      Complete Setup
                    </button>
                  </Link>

                  {/* Secondary action */}
                  <button
                    style={{
                      marginTop: 10,
                      background: "none",
                      border: "none",
                      color: "#9CA3AF",
                      fontSize: 13,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      this.setState({ missingDialogOpen: false, missingItem: null })
                    }
                  >
                    Maybe later
                  </button>
                </div>
              </Dialog>
            )}

            <div className="row w-100 mt-4 mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                {/* <div className="d-flex align-items-center mb-2" style={{ gap: "10px" }}>
                      <span style={{ fontSize: 13, fontWeight: 500 }}>Catalogue Management</span>
                      <div
                        onClick={() => this.setState({ catalogueModal: !this.state.catalogueModal })}
                        style={{
                          width: 42,
                          height: 22,
                          borderRadius: 11,
                          backgroundColor: this.state.catalogueModal ? "#0d6efd" : "#ccc",
                          cursor: "pointer",
                          position: "relative",
                          transition: "background-color 0.2s",
                          flexShrink: 0,
                        }}
                      >
                        <div
                          style={{
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                            position: "absolute",
                            top: 3,
                            left: this.state.catalogueModal ? 23 : 3,
                            transition: "left 0.2s",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                          }}
                        />
                      </div>
                    </div> */}
              </div>



              {(!hideMMLite && this.state.route === 41 && this.state.wabaId && this.state.phoneNumberId
                && this.state.whatsappNumber.some(item => item.status === 1 && item.mmlite_signup === 0 && item.show_mmlite_button === 1)) &&
                (
                  <div className="d-flex justify-content-center align-items-center mt-2">
                    <iframe
                      src={`https://console.authkey.io/wabakmmlite/index.php?user_id=${this.state.userId}&user_name=${this.state.username}&waba_id=${this.state.wabaId}&phone_number_id=${this.state.phoneNumberId}`}
                      width="400"
                      height="250"
                      title="MM Lite Embeded Signup"
                      frameBorder="0"
                    />
                  </div>
                )}
              {(hideMMLite && this.state.route === 41 && this.state.wabaId && this.state.phoneNumberId
                && this.state.whatsappNumber.some(item => item.status === 1 && item.mmlite_signup === 0 && item.show_mmlite_button === 1)) &&
                (
                  <div className="d-flex justify-content-center align-items-center mt-2">
                    <iframe
                      src={`https://whatsapp.adznetworkmedia.om/wabaadzmml/index.php?user_id=${this.state.userId}&user_name=${this.state.username}&waba_id=${this.state.wabaId}&phone_number_id=${this.state.phoneNumberId}`}
                      width="400"
                      height="250"
                      title="MM Lite Embeded Signup"
                      frameBorder="0"
                    />
                  </div>
                )}
              {(this.state.route === 41
                && this.state.whatsappNumber.some(item => item.status === 1 && item.mmlite_signup === 1 && item.show_mmlite_button === 1)) &&
                (
                  <div className="d-flex justify-content-center align-items-center">
                    <p>MMLite Embedded Signup Already Done</p>
                  </div>
                )}
            </div>
            <div></div>
            {this.state.metaStatusActive &&
              <div
                className="translate-middle mt-3 p-4 bg-white border border-2 rounded shadow-lg"
                style={{ position: 'absolute', zIndex: 1050, width: '90%', maxWidth: '900px', maxHeight: '80vh', overflowY: 'auto' }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Meta Status</h5>
                  <span
                    onClick={() => this.setState({ metaStatusActive: false })}
                    style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.5rem' }}
                  >
                    &times;
                  </span>
                </div>

                <table className="table table-sm table-striped mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Phone Number ID</th>
                      <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Account Mode</th>
                      <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Phone Number</th>
                      <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Message Limit</th>
                      <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Quality Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.checkMetaStatusData.length > 0 && this.state.checkMetaStatusData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item?.id}</td>
                        <td>{item?.account_mode}</td>
                        <td>{item?.display_phone_number}</td>
                        <td>{item?.whatsapp_business_manager_messaging_limit}</td>
                        <td>{item?.quality_score?.score === "GREEN" ? <span style={{ color: "#4ec9b0" }}>{item?.quality_score?.score}</span> : item?.quality_score?.score === "YELLOW" ? <span style={{ color: "#ffbe3d" }}>{item?.quality_score?.score}</span> : <span style={{ color: "red" }}>{item?.quality_score?.score}</span>}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            }
            {this.state.metaStatusError && (
              <div style={{
                position: 'fixed', top: 20, left: '50%', transform: 'translateX(-50%)',
                zIndex: 9999, display: 'flex', alignItems: 'center', gap: 10,
                background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 10,
                padding: '10px 18px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                fontSize: 13, color: '#92400e', fontWeight: 500, whiteSpace: 'nowrap',
              }}>
                <BsExclamationCircleFill size={16} color="#d97706" />
                Health status check is not available for this account.
                <button
                  onClick={() => this.setState({ metaStatusError: false })}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#b45309', fontSize: 16, lineHeight: 1, marginLeft: 4 }}
                >
                  &times;
                </button>
              </div>
            )}


          </div>

          {/* Catalogue ID Popup */}
          {this.state.catalogueModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 2000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => this.setState({ catalogueModal: false })}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: 10,
                  padding: "28px 24px 20px",
                  width: 360,
                  boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
                  position: "relative",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => this.setState({ catalogueModal: false })}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 14,
                    background: "none",
                    border: "none",
                    fontSize: 20,
                    cursor: "pointer",
                    color: "#6b7280",
                    lineHeight: 1,
                  }}
                >
                  &times;
                </button>

                <h6 style={{ fontWeight: 600, marginBottom: 4, fontSize: 16 }}>
                  Enter Catalogue ID
                </h6>
                <p style={{ fontSize: 12, color: "#6B7280", marginBottom: 16 }}>
                  Provide the catalogue ID to link with your WhatsApp account.
                </p>

                <input
                  type="text"
                  className="form-control form-control-sm mb-3"
                  placeholder="Enter Catalogue ID"
                  value={this.state.catalogueId}
                  onChange={(e) => this.setState({ catalogueId: e.target.value })}
                />

                <div className="d-flex justify-content-end" style={{ gap: 8 }}>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => this.setState({ catalogueModal: false, catalogueId: "" })}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => {
                      if (!this.state.catalogueId.trim()) return;
                      // TODO: handle catalogue ID submit
                      // console.log("Catalogue ID:", this.state.catalogueId);
                      this.setState({ catalogueModal: false, catalogueId: "" });
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>

      </DashboardLayout>
    );
  }
}

export default WhatsappNumberList;
